<template>
  <div class="grouped-routes">
    <div v-for="(sortedItems, group, index) of sorted" :key="index">
      <div v-if="sortedItems.length > 1" class="text-left">
        <div class="checkbox">
          <label>
            <input
                :id="group"
                v-model="checked"
                type="checkbox"
                :data-id="group"
                :data-is-group="true"
                :value="group"
                @change="change"
            >
            <strong>{{ group }}:</strong>
          </label>
        </div>
      </div>
      <div v-for="(route, index2) in sortedItems" :key="index2" :class="{ multiple: sortedItems.length > 1 }" class="text-left">
        <div class="checkbox">
          <label>
            <input
                v-model="checked"
                type="checkbox"
                :class="inputClass"
                :data-id="route.id"
                :value="route.id"
                :data-group="group"
                :disabled="disabled(route)"
                @change="change"
            >
            <strong v-text="route.name"></strong>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Number,
      default: null,
    },
    inputClass: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      checked: [],
    }
  },
  computed: {
    sorted: function () {
      if (undefined === this.items) {
        return []
      }
      const itemsCopy = [...this.items]
      return itemsCopy.sort((a, b) => {
        [a, b] = [a, b].map((i) => {
          i = i.name || ''
          i = (i.includes('WA_') ? '1' : '2') + i
          return i
        })

        return a.localeCompare(b)
      }
      ).reduce((a, c) => {
        if (undefined !== c) {
          const g = c.name.replace(/(?:(WA_0\d{1})|([^_]+_))(.*)/, '$1$2')
          if (undefined === a[g]) {
            a[g] = []
          }
          a[g].push(c)
        }

        return a
      }, {})
    }
  },
  watch: {
    loading() {
      this.checked = []
    }
  },
  methods: {
    change(e) {
      if (e.target.dataset.isGroup) {
        this.sorted[e.target.value].forEach(g => {
          const index = this.checked.findIndex(i => g.id === i)

          if (e.target.checked && index < 0 && !this.disabled(g)) {
            this.checked.push(g.id)
          }
          if (!e.target.checked && index >= 0) {
            delete this.checked[index]
          }
        })
      } else {
        const selectedGroupIndex = this.checked.findIndex(i => e.target.dataset.group === i)
        if (!e.target.checked) {
          delete this.checked[selectedGroupIndex]
        } else {
          const selectedInParentGroup = this.checked.filter(c => {
            return this.sorted[e.target.dataset.group].find(s => s.id === c)
          })
          if (selectedInParentGroup.length === this.sorted[e.target.dataset.group].length && selectedGroupIndex < 0) {
            this.checked.push(e.target.dataset.group)
          }
        }
      }
    },
    disabled(route) {
      return this.inputClass !== 'routes_to_assign_checkbox' && route.sorter_changeable_parts === 0
    }
  }
}
</script>
